import { Badge, Text, Tooltip } from 'design-system';
import { orderSourceMeta } from '../utils/order-source';

export interface IOrderSourceCell {
  source: unknown;
}

export const OrderSourceCell = ({ source }: IOrderSourceCell) => {
  const meta = orderSourceMeta(source);
  if (!meta) return <Text color='gray.400'>—</Text>;

  return (
    <Tooltip label={meta.description} hasArrow openDelay={300}>
      <Badge
        colorScheme={meta.colorScheme}
        variant='subtle'
        borderRadius='full'
        px='sm'
        py='2px'
        fontSize='xs'
        fontWeight='semibold'
        textTransform='none'>
        {meta.label}
      </Badge>
    </Tooltip>
  );
};
